// @internal
import styled, { css } from 'styled-components';
import { sidenavTokens } from '../../tokens/components/SideNav/tokens';

export const OutlineStyles = css`
  &:focus-visible {
    outline: 2px solid #176bb8;
    outline-offset: -2px;
  }
`;

export const ResetButton = css`
  background-color: transparent;
  border: none;
`;

export interface StyledSideNavWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  isCompact: boolean;
  isMobile?: boolean;
}

export const StyledSideNavWrapper = styled.div<StyledSideNavWrapperProps>`
  height: 100%;

  ${({ isMobile, isCompact }) =>
    isCompact &&
    css`
      width: ${sidenavTokens.WrapperWidthBaseClosed};

      ${isMobile &&
      css`
        width: 0;
      `}
    `}
`;

export type StyledSideNavProps = {
  $width?: string;
  isClosed: boolean;
  isCompact: boolean;
  isMobile?: boolean;
  isActive?: boolean;
  hideFilter?: boolean;
};

export const StyledSideNav = styled.nav<StyledSideNavProps>`
  background-color: ${sidenavTokens.WrapperColorBackgroundBaseDefault};
  border-right: ${sidenavTokens.WrapperBorderBaseVisible};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: start;
  overflow-x: hidden;
  transition: ${`width ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault},
          padding ${sidenavTokens.TransitionDurationBaseDefault} ${sidenavTokens.TransitionCurveBaseDefault}`};
  padding: ${({ isClosed, hideFilter }) =>
    hideFilter
      ? css`
          ${isClosed
            ? `${sidenavTokens.WrapperPaddingTopBaseClosed} 0 0 0`
            : `${sidenavTokens.WrapperPaddingTopBaseOpen} 0 0 0`}
        `
      : css`
          ${sidenavTokens.WrapperPaddingTopBaseOpen} 0 0 0
        `};
  width: ${({ $width, isClosed, isMobile }) => {
    if ($width) {
      return $width;
    }
    if (isClosed) {
      return isMobile ? '0' : sidenavTokens.WrapperWidthBaseClosed;
    }
    return isMobile ? sidenavTokens.WrapperWidthMobileOpen : sidenavTokens.WrapperWidthBaseOpen;
  }};

  @media print {
    display: none;
  }

  ${({ isCompact }) =>
    isCompact &&
    css`
      position: absolute;
      z-index: ${sidenavTokens.WrapperElevationCompactDefault};
    `}
`;
